import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {PlaceholderWrapperComponent} from "../../placeholder/placeholder-wrapper";
import {DeviceViewModel} from "../../../models/device.view-model";
import {Calendar} from "../../../icons/calendar";
import {RightArrow} from "../../../icons/arrows/right-arrow";
import {LeftArrow} from "../../../icons/arrows/left-arrow";
import {useThemeColor} from "../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../app/consts/colors";

export class ScoresHeaderSubHeaderPlaceholderProps extends BaseProps {
  device: DeviceViewModel;
}

export const ScoresHeaderSubHeaderPlaceholder = (props: ScoresHeaderSubHeaderPlaceholderProps) => {
  const grayPrimary = useThemeColor(COLORS.grayPrimary)
  return (
    <PlaceholderWrapperComponent className={'scores-header-placeholder-sub-header-container'}>
      <div className={'scores-header-placeholder-sub-header-content'}>
        {props.device.isRtl ? <RightArrow fill={grayPrimary}/> : <LeftArrow fill={grayPrimary}/>}
        <div className={'scores-header-placeholder-sub-header-date'}/>
        {props.device.isRtl ? <LeftArrow fill={grayPrimary}/> : <RightArrow fill={grayPrimary}/>}
        <div className={'scores-header-placeholder-sub-header-calendar'}>
          <Calendar fill={grayPrimary}/>
        </div>
      </div>
    </PlaceholderWrapperComponent>
  )
}
